import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5dc2c718&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc2c718",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dc2c718')) {
      api.createRecord('5dc2c718', component.options)
    } else {
      api.reload('5dc2c718', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5dc2c718&scoped=true", function () {
      api.rerender('5dc2c718', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nest/menu1/index.vue"
export default component.exports